class Step2Controller {
    constructor($state, BookFactory) {
        this.name = 'step2'

        this.$state = $state
        this.BookFactory = BookFactory
    }

    $onInit() {
        this.generateBook()
    }

    generateBook() {
        if (this.$state.params.type === 'facebook') {
            this.getFacebookBook()
        } else {
            this.getGuestBook()
        }
    }

    getFacebookBook() {
        this.BookFactory.generateFacebookBook()
            .then((data) => {
                const {
                    bookId
                } = data

                localStorage.setItem('tourists_bookId', bookId)

                if (this.$state.current.name === 'home.book.bookStep2') {
                    this.$state.go('home.book.bookStep3', {
                        bookId
                    }, {
                        reload: true
                    })
                } else if (this.$state.current.name === 'bookMobile.bookMobileStep2') {
                    this.$state.go('bookMobile.bookMobileStep3', {
                        bookId
                    }, {
                        reload: true
                    })
                }
            })
            .catch((err) => {
                console.log('Error occured in method getFacebookBook', err)

                this.error = err.data
            })
    }

    getGuestBook() {
        let interests

        try {
            interests = JSON.parse(sessionStorage.getItem('tourists_interests'))
        } catch (e) {
            interests = []
        }

        this.BookFactory.generateGuestBook(interests)
            .then((data) => {
                const {
                    bookId
                } = data

                localStorage.setItem('tourists_bookId', bookId)

                if (this.$state.current.name === 'home.book.bookStep2') {
                    this.$state.go('home.book.bookStep3', {
                        bookId
                    }, {
                        reload: true
                    })
                } else if (this.$state.current.name === 'bookMobile.bookMobileStep2') {
                    this.$state.go('bookMobile.bookMobileStep3', {
                        bookId
                    }, {
                        reload: true
                    })
                }
            })
            .catch((err) => {
                console.log('Error occured in method getGuestBook', err)

                this.error = err.data
            })
    }
}

Step2Controller.$inject = ['$state', 'BookFactory']

export default Step2Controller



// WEBPACK FOOTER //
// ./client/app/components/home/book/step2/step2.controller.js